import * as React from "react";
import {Button, capitalizeFirstLetter} from "@vebox/etui-core";
import {LoadingButton} from "../components/buttons/LoadingButton";
import {AppTranslations} from "../components/Utils/translations/AppTranslations";
import {Display} from "../components/Display";


declare var AppTranslations: AppTranslations;

interface FormCardFooterProps {
    onReset?: () => void;
    onNext: () => void;
    nextButtonText?: string;
    restButtonText?: string;
    disabled?: boolean;
    disabledCancel?: boolean;
    loadable?: boolean;
    loading?: boolean;
    rootDivStyle?: React.CSSProperties;
}

export const FormCardFooter: React.FC<FormCardFooterProps> = (props) => {
    return (
        <div className={"form-card-footer flx-row flx-end"} style={props?.rootDivStyle}>
            <Display isVisible={props?.onReset}>
                <Button
                    variant={"tertiary"}
                    onClick={props.onReset}
                    disabled={props.disabledCancel}
                >{capitalizeFirstLetter(props.restButtonText ?? AppTranslations.userCreationProcess.reset)}</Button>
            </Display>
            {
                props.loadable
                    ? (
                        <LoadingButton
                            variant={"strong"}
                            onClick={props.onNext}
                            disabled={props.disabled}
                            loading={props.loading}
                        >
                            {capitalizeFirstLetter(props.nextButtonText ?? AppTranslations.userCreationProcess.next)}
                        </LoadingButton>
                    )
                    : (
                        <Button
                            variant={"strong"}
                            onClick={props.onNext}
                            disabled={props.disabled}
                        >
                            {capitalizeFirstLetter(props.nextButtonText ?? AppTranslations.userCreationProcess.next)}
                        </Button>
                    )
            }
        </div>
    )
}